export const CustomColorItem = (props: any) => {
    let pastilleColor = '';
    let backgroundTacheColor = ''
    if (props.modeVente !== undefined) {
        switch (props.modeVente) {
            case null:
                pastilleColor = '#535353';
                break;
            case 'A Livrer':
                pastilleColor = '#FAFF5C';
                break;
            case 'Vente avec service (VAS)':
                pastilleColor = '#FF4A4A';
                break;
            case 'Vente directe':
                pastilleColor = '#5CFFCE';
                break;
            case 'A emporter':
                pastilleColor = '#9090ff';
                break;
            default:
                pastilleColor = '#888888';
        }
    } else {
        switch (props.v_mode_vente) {
            case null:
                pastilleColor = '#535353';
                break;
            case 'A Livrer':
                pastilleColor = '#FAFF5C';
                break;
            case 'Vente avec service (VAS)':
                pastilleColor = '#FF4A4A';
                break;
            case 'Vente directe':
                pastilleColor = '#5CFFCE';
                break;
            case 'A emporter':
                pastilleColor = '#9090ff';
                break;
            default:
                pastilleColor = '#888888';
        }
    }
    switch (props.dataItem.v_lib_avancement) {
        case null:
            backgroundTacheColor = '#9E9E9E';
            break;
        case 'En cours':
            backgroundTacheColor = '#322FFF';
            break;
        case 'Prise de contact - Plaquette envoyée':
            backgroundTacheColor = '#2D5B30';
            break;
        case 'Accepté':
            backgroundTacheColor = '#2FFF3F';
            break;
        default:
            backgroundTacheColor = 'green';
    }
    return { pastilleColor, backgroundTacheColor };
}
export const CustomColorMonthItem = (task: any) => {
    let pastilleColor = '';
    let backgroundTacheColor = '';

    // Déterminer la couleur de la pastille en fonction de `modeVente`
    if (task.modeVente !== undefined) {
        switch (task.modeVente) {
            case null:
                pastilleColor = '#535353';
                break;
            case 'A Livrer':
                pastilleColor = '#FAFF5C';
                break;
            case 'Vente avec service (VAS)':
                pastilleColor = '#FF4A4A';
                break;
            case 'Vente directe':
                pastilleColor = '#5CFFCE';
                break;
            case 'A emporter':
                pastilleColor = '#9090ff';
                break;
            default:
                pastilleColor = '#888888';
        }
    } else {
        switch (task.v_mode_vente) {
            case null:
                pastilleColor = '#535353';
                break;
            case 'A Livrer':
                pastilleColor = '#FAFF5C';
                break;
            case 'Vente avec service (VAS)':
                pastilleColor = '#FF4A4A';
                break;
            case 'Vente directe':
                pastilleColor = '#5CFFCE';
                break;
            case 'A emporter':
                pastilleColor = '#9090ff';
                break;
            default:
                pastilleColor = '#888888';
        }
    }

    // Déterminer la couleur de fond de la tâche en fonction de `v_lib_avancement`
    switch (task.v_lib_avancement) {
        case null:
            backgroundTacheColor = '#9E9E9E'; // Gris
            break;
        case 'En cours':
            backgroundTacheColor = '#322FFF'; // Bleu
            break;
        case 'Prise de contact - Plaquette envoyée':
            backgroundTacheColor = '#2D5B30'; // Vert
            break;
        case 'Accepté':
            backgroundTacheColor = '#2FFF3F'; // Vert clair
            break;
        default:
            backgroundTacheColor = 'green'; // Couleur par défaut si aucune correspondance
    }

    return { pastilleColor, backgroundTacheColor };
};

export const CustomColorWeekItem = (task: any) => {
    let pastilleColor = '';
    let backgroundTacheColor = '';
    if (task.modeVente !== undefined) {
        switch (task.modeVente) {
            case null:
                pastilleColor = '#535353';
                break;
            case 'A Livrer':
                pastilleColor = '#FAFF5C';
                break;
            case 'Vente avec service (VAS)':
                pastilleColor = '#FF4A4A';
                break;
            case 'Vente directe':
                pastilleColor = '#5CFFCE';
                break;
            case 'A emporter':
                pastilleColor = '#9090ff';
                break;
            default:
                pastilleColor = '#888888';
        }
    } else {
        switch (task.v_mode_vente) {
            case null:
                pastilleColor = '#535353';
                break;
            case 'A Livrer':
                pastilleColor = '#FAFF5C';
                break;
            case 'Vente avec service (VAS)':
                pastilleColor = '#FF4A4A';
                break;
            case 'Vente directe':
                pastilleColor = '#5CFFCE';
                break;
            case 'A emporter':
                pastilleColor = '#9090ff';
                break;
            default:
                pastilleColor = '#888888';
        }
    }
    switch (task.v_lib_avancement) {
        case null:
            backgroundTacheColor = 'pink';
            break;
        case 'En cours':
            backgroundTacheColor = 'blue';
            break;
        case 'Prise de contact - Plaquette envoyée':
            backgroundTacheColor = 'purple';
            break;
        case 'Accepté':
            backgroundTacheColor = 'green';
            break;
        default:
            backgroundTacheColor = 'black';
    }
    return { pastilleColor, backgroundTacheColor };
}
